<template>
	<v-container>
		<!-- <v-app-bar app color="orange">
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title class="white--text">
				Administração
			</v-toolbar-title>
		</v-app-bar> -->

		<v-page-header :color="$root.colorHeader" :titulo="$root.titleHeader" />

		<v-card tile>
			<v-card-title primary-title>
				Usuários
			</v-card-title>
			<v-list>
				<template v-for="(usuario, index) in usuarios">
					<v-divider v-if="index > 0" :key="'d' + index"></v-divider>
					<v-list-item :key="usuario.id">
						<v-list-item-avatar :color="colorFromName(usuario.nome)">
							<span class="white--text headline">{{
								iniciais(usuario.nome)
							}}</span>
						</v-list-item-avatar>

						<v-list-item-content>
							<v-list-item-title>{{ usuario.nome }}</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action >
							<v-select
								class="pt-4"
								:items="secretariasItems"
								v-model="usuario.secretaria"
								label="Secretaria"
								no-data-text="Secretarias não carregadas"
								clearable
								item-text="nome"
								item-value="id"
								return-object
								@change="alteracaoSecretaria(usuario)"
								placeholder="Sem secretaria definida"
							></v-select>
						</v-list-item-action>
					</v-list-item>
				</template>
			</v-list>
		</v-card>
	</v-container>
</template>

<script>

import VPageHeader from '@/components/PageHeader.vue';

export default {
	data() {
		return {
			usuarios: [],

			secretariasItems: []
		};
	},

	components: {VPageHeader},

	created() {
		this.fetchUsuarios();
		this.fetchSecretarias();

		this.$root.colorHeader = "orange";
		this.$root.titleHeader = "Administração";

	},

	methods: {
		async fetchUsuarios() {
			try {
				this.usuarios = await this.$fetch.get('usuarios');
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar usuários',
					msg: err.msg
				};
			}
		},
		iniciais(nome) {
			let arrNome = nome.split(' ');
			return arrNome[0][0] + arrNome[arrNome.length - 1][0];
		},
		colorFromName(name) {
			let firstCharCode = name.toUpperCase().charCodeAt(0) - 65;
			let hue = (firstCharCode * 360) / 26;

			return `hsl(${hue}, 80%, 50%)`;
		},
		async fetchSecretarias() {
			try {
				this.secretariasItems = await this.$fetch.get('emendas/secretarias');
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar secretarias',
					msg: err.msg
				};
			}
		},

		async alteracaoSecretaria(usuario) {
			try {
				await this.$fetch.post('usuarios/vincularSecretaria', usuario);
				this.$emit('snack', {
					show: true,
					text: usuario.secretaria ? `${usuario.nome} alterado para ${usuario.secretaria.nome}` : `${usuario.nome} sem secretaria associada.`
				});
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível alterar secretaria do usuário',
					msg: err.msg
				};
			}
		}
	}
};
</script>
